var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('branch-offices',{attrs:{"branchoffices":_vm.branchoffices,"priceslists":_vm.priceslists,"funds":_vm.funds}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }